export default __webpack_public_path__ + "static/media/avatar.67f38aa4.png";